import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import LoadingSpinner from '../../components/ui/LoadingSpinner';

const ForgotPasswordPage: React.FC = () => {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');
    setMessage('');

    try {
      // Simulate API call
      await new Promise(resolve => setTimeout(resolve, 2000));
      setMessage('Instruções de recuperação de senha foram enviadas para seu e-mail.');
    } catch (err: any) {
      setError('Erro ao enviar instruções de recuperação');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex">
      {/* Left side - Forgot Password Form */}
      <div className="flex-1 flex items-center justify-center bg-white px-4 sm:px-6 lg:px-20 xl:px-24">
        <div className="mx-auto w-full max-w-sm lg:w-96">
          <div>
            <h1 className="text-2xl font-bold text-gray-900 mb-2">
              Wabby<span className="text-gray-600">Call</span>
            </h1>
            <h2 className="text-xl font-semibold text-gray-900 mb-2">
              Recuperar senha
            </h2>
            <p className="text-sm text-gray-600 mb-8">
              Informe seu e-mail abaixo para receber as instruções de recuperação de senha
            </p>
          </div>

          <form className="space-y-6" onSubmit={handleSubmit}>
            <div>
              <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                E-mail
              </label>
              <input
                id="email"
                name="email"
                type="email"
                autoComplete="email"
                required
                className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:ring-cyan-500 focus:border-cyan-500 sm:text-sm"
                placeholder="Digite seu e-mail"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>

            {error && (
              <div className="rounded-md bg-red-50 p-4">
                <div className="text-sm text-red-700">{error}</div>
              </div>
            )}

            {message && (
              <div className="rounded-md bg-green-50 p-4">
                <div className="text-sm text-green-700">{message}</div>
              </div>
            )}

            <div>
              <button
                type="submit"
                disabled={isLoading}
                className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-cyan-500 hover:bg-cyan-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {isLoading ? (
                  <LoadingSpinner size="sm" />
                ) : (
                  'RECUPERAR SENHA'
                )}
              </button>
            </div>

            <div className="text-center">
              <Link
                to="/login"
                className="text-sm font-medium text-cyan-600 hover:text-cyan-500"
              >
                ← Voltar para o login
              </Link>
            </div>
          </form>
        </div>
      </div>

      {/* Right side - Welcome Message with Gradient Background */}
      <div className="hidden lg:block relative w-0 flex-1">
        <div className="absolute inset-0 bg-gradient-to-br from-cyan-400 via-cyan-500 to-blue-600">
          {/* Decorative elements */}
          <div className="absolute top-8 right-8">
            <div className="grid grid-cols-6 gap-2">
              {[...Array(18)].map((_, i) => (
                <div key={i} className="w-2 h-2 bg-white bg-opacity-30 rounded-full"></div>
              ))}
            </div>
          </div>
          
          <div className="absolute top-1/4 left-8">
            <div className="w-16 h-16 border-4 border-white border-opacity-30 rounded-full"></div>
          </div>
          
          <div className="absolute bottom-1/4 right-16">
            <div className="w-24 h-24 bg-white bg-opacity-10 rounded-full"></div>
          </div>

          {/* Curved decorative lines */}
          <svg className="absolute top-0 left-0 w-full h-full" viewBox="0 0 400 600" fill="none">
            <path
              d="M-50 200C100 150 200 250 350 200"
              stroke="rgba(255,255,255,0.2)"
              strokeWidth="2"
              fill="none"
            />
            <path
              d="M-50 350C100 300 200 400 350 350"
              stroke="rgba(255,255,255,0.1)"
              strokeWidth="2"
              fill="none"
            />
          </svg>

          {/* Main content */}
          <div className="relative z-10 h-full flex items-center justify-center px-8">
            <div className="text-center text-white">
              <div className="mb-8">
                <div className="w-20 h-20 mx-auto mb-4 bg-white bg-opacity-20 rounded-full flex items-center justify-center">
                  <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center">
                    <div className="w-6 h-6 bg-cyan-500 rounded-full"></div>
                  </div>
                </div>
              </div>
              <h1 className="text-4xl font-bold mb-4">
                Seja bem vindo<br />
                ao WabbyCall
              </h1>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;